import { render, staticRenderFns } from "./FormInputProjectLibraryPersonnelCostsWidget.vue?vue&type=template&id=06c0c067&"
import script from "./FormInputProjectLibraryPersonnelCostsWidget.vue?vue&type=script&lang=js&"
export * from "./FormInputProjectLibraryPersonnelCostsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports